import { render, staticRenderFns } from "./HowtoGetRegisterCode.vue?vue&type=template&id=10806bfe&scoped=true&"
import script from "./HowtoGetRegisterCode.vue?vue&type=script&lang=js&"
export * from "./HowtoGetRegisterCode.vue?vue&type=script&lang=js&"
import style0 from "./HowtoGetRegisterCode.vue?vue&type=style&index=0&id=10806bfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10806bfe",
  null
  
)

export default component.exports